const showModal = (id, data) => {
  document.dispatchEvent(
    // eslint-disable-next-line no-undef
    new CustomEvent('showModal', {
      detail: { id, data }
    })
  )
}

const hideModal = (id) => {
  document.dispatchEvent(
    // eslint-disable-next-line no-undef
    new CustomEvent('hideModal', {
      detail: { id }
    })
  )
}

export { showModal, hideModal }
